import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import React from "react";

export const StyledCheckbox: React.FC<CheckboxProps> = (props) => (
  <Checkbox borderColor="mdGrey" {...props} />
);
